// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#secao-anexo[data-v-76c43f39] {\n  margin-top: 0px;\n}\n.container-adicionar-anexo[data-v-76c43f39] {\n  margin-top: 5px;\n}\n.msg-confirmar-exlusao[data-v-76c43f39] {\n  padding-left: 35px !important;\n}\n.simple-table-anexos[data-v-76c43f39] {\n  overflow-y: auto;\n  max-height: 200px;\n  scrollbar-width: thin;\n  scrollbar-color: #969696 #dbdbdb;\n}", ""]);
// Exports
module.exports = exports;
